export const pageTitle = {
  'Tracker Settings': '追蹤設定',
  'Marketing & Tracker': '網店行銷及追蹤',
  'Add Event Tracker': '新增追蹤工具',
  'Add Event Tracker_edit': '編輯追蹤工具',
  Apps: '擴充功能',
  'Apps Store': '擴充功能商店',
};
